import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService, LanguageService, ProductSearchService, RoutingService } from '@spartacus/core';
import { ProductListComponentService, ProductListRouteParams, ViewConfig } from '@spartacus/storefront';
import { BehaviorSubject } from 'rxjs';

export interface PageRouteDetails {
  category: string;
  url?: string;
}

export enum ShimanoPLPConstants {
  IN_STOCK_OUT_OF_STOCK_QUERY = ':stockStatusDisplay:inStock:stockStatusDisplay:outOfStock',
  IN_STOCK_QUERY = ':stockStatusDisplay:inStock',
  OUT_OF_STOCK_QUERY = ':stockStatusDisplay:outOfStock',
}

@Injectable({
  providedIn: 'root',
})
export class ShimanoProductListComponentService extends ProductListComponentService {
  protected defaultPageSize = 24;
  relevance = ':relevance:category:';
  collapsedFacets$ = new BehaviorSubject<Set<string>>(new Set());
  showMoreFacets$ = new BehaviorSubject<string[]>(null);

  constructor(
    productSearchService: ProductSearchService,
    routing: RoutingService,
    activatedRoute: ActivatedRoute,
    currencyService: CurrencyService,
    languageService: LanguageService,
    router: Router,
    config: ViewConfig
  ) {
    super(productSearchService, routing, activatedRoute, currencyService, languageService, router, config);
  }

  getQueryFromRouteParams({ query, categoryCode, brandCode }: ProductListRouteParams) {
    if (query) {
      return query;
    }
    if (categoryCode) {
      return this.relevance + categoryCode;
    }
    // similarly as any category.
    if (brandCode) {
      return this.relevance + brandCode;
    }
  }

  addInStockOutOfStockFlag(url: string) {
    let additionalQuery: string;
    let hasBothInStockOutOfStockQuery = url.includes('inStock') && url.includes('outOfStock');

    if (!hasBothInStockOutOfStockQuery) {
      // url only has inStock
      if (url.includes('inStock')) {
        additionalQuery = ShimanoPLPConstants.OUT_OF_STOCK_QUERY;
      }
      // url only has outOfStock
      else if (url.includes('outOfStock')) {
        additionalQuery = ShimanoPLPConstants.IN_STOCK_QUERY;
      }
      // url has no inStock and outOfStock
      else {
        additionalQuery = ShimanoPLPConstants.IN_STOCK_OUT_OF_STOCK_QUERY;
      }

      this.router.navigateByUrl(url + additionalQuery);
    }
  }
}
